import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MyWalletComponent } from './my-wallet.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared.module';
import { MyWalletMovementsDialogComponent } from './my-wallet-movements-dialog.component';

@NgModule({
  imports: [
    SharedModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [MyWalletComponent, MyWalletMovementsDialogComponent]
})
export class MyWalletModule {}
